/* Sale banner — film-strip parallax. Loaded globally from theme.liquid;
   binds itself to .sale-band whenever it appears in the DOM. */
(function () {
  if (window.__merenusSaleBandParallax) return;
  window.__merenusSaleBandParallax = true;

  function bind(band) {
    if (!band || band.dataset.parallaxBound) return;
    band.dataset.parallaxBound = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cols = band.querySelectorAll('.sale-band__film-col');
    if (!cols.length) return;
    var running = false;
    function loop() {
      if (!running) return;
      var r = band.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      if (r.bottom > -120 && r.top < vh + 120) {
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        p = Math.max(-1, Math.min(1, p));
        var AMP = (window.innerWidth < 760) ? 140 : 280;
        for (var i = 0; i < cols.length; i++) {
          var dir = (i % 2 === 0) ? 1 : -1; /* strips alternate: down, up, down, up, down */
          cols[i].style.transform = 'translateY(' + (p * AMP * dir).toFixed(1) + 'px)';
        }
      }
      requestAnimationFrame(loop);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var vis = entries[0].isIntersecting;
        if (vis && !running) { running = true; requestAnimationFrame(loop); }
        if (!vis) running = false;
      }, { rootMargin: '120px' }).observe(band);
    } else {
      running = true;
      requestAnimationFrame(loop);
    }
  }

  function scan() {
    var bands = document.querySelectorAll('.sale-band');
    for (var i = 0; i < bands.length; i++) bind(bands[i]);
  }

  function start() {
    scan();
    if ('MutationObserver' in window) {
      new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
    } else {
      setInterval(scan, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
